import { AnyIfEmpty } from 'react-redux';
import { CSSObjectWithLabel, GroupBase, OptionProps, StylesConfig } from 'react-select';

import { SelectProps, Tab } from '../components/locations/interfaces/locations.interface';
import { isValidHttpUrl } from '../utils/utils';

export interface LockerOption {
    value: number;
    label: number;
    zipRegex?: RegExp;
}

export interface LockerVersion {
    value: string;
    label: string;
}

export interface StatusOption {
    value: string;
    label: string;
}

export interface OfficeHoursOption {
    day: string;
    openTime: string;
    closeTime: string;
    isOpen: boolean;
}

export const Roles: AnyIfEmpty<object> = [
    { value: 'AdminRole', label: 'Admin' },
    { value: 'GeneralManagerRole', label: 'General Manager' },
    { value: 'PropertyManagerRole', label: 'Property Manager' },
    { value: 'LeasingAgentRole', label: 'Leasing Agent' },
    { value: 'MaintenanceRole', label: 'Maintenence' },
];

export const Bedrooms: AnyIfEmpty<object> = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
];

export const MAX_FILE_SIZE = 52428800;

export const CONVERSATION_PAGE_SIZE = 30;

export const getLocationTimeZone = (zone: string) => {
    return TimeZones?.find((timeZone: { value: string; label: string }) => zone === timeZone?.value)?.label || '';
};

export const TimeZones: AnyIfEmpty<object> = [
    { value: 'America/New_York', label: 'Eastern Time' },
    { value: 'America/Chicago', label: 'Central Time' },
    { value: 'America/Denver', label: 'Mountain Time' },
    { value: 'America/Los_Angeles', label: 'Pacific Time' },
    { value: 'America/Anchorage', label: 'Alaska Time' },
    { value: 'Pacific/Honolulu', label: 'Hawaii-Aleutian Time' },
];

export const ReportSendTimes: AnyIfEmpty<object> = [
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Quarterly', label: 'Quarterly' },
];

export const SelectedLockers: LockerOption[] = [
    // { value: 0, label: 'Variable (Luxer)' },
    { value: 4, label: 4 },
    { value: 10, label: 10 },
    { value: 12, label: 12 },
];

export const statusEnum: StatusOption[] = [
    { label: 'Active', value: 'Active' },
    { label: 'Testing', value: 'Testing' },
    { label: 'Preparation', value: 'Preparation' },
    { label: 'Inactive', value: 'Inactive' },
];

export const lockerOptions: { value: number; label: string }[] = [
    { value: 0, label: 'Select Locker' },
    { value: 1, label: '01' },
    { value: 2, label: '02' },
    { value: 3, label: '03' },
    { value: 4, label: '04' },
    { value: 5, label: '05' },
    { value: 6, label: '06' },
    { value: 7, label: '07' },
    { value: 8, label: '08' },
    { value: 9, label: '09' },
    { value: 10, label: '10' },
];

export const resources10Lockers = [
    { id: 'a', locker_number: 1, title: 'Locker 1' },
    { id: 'b', locker_number: 2, title: 'Locker 2' },
    { id: 'c', locker_number: 3, title: 'Locker 3' },
    { id: 'd', locker_number: 4, title: 'Locker 4' },
    { id: 'e', locker_number: 5, title: 'Locker 5' },
    { id: 'f', locker_number: 6, title: 'Locker 6' },
    { id: 'g', locker_number: 7, title: 'Locker 7' },
    { id: 'h', locker_number: 8, title: 'Locker 8' },
    { id: 'i', locker_number: 9, title: 'Locker 9' },
    { id: 'j', locker_number: 10, title: 'Locker 10' },
];

export const resources12Lockers = [
    { id: 'a', locker_number: 1, title: 'Locker 1' },
    { id: 'b', locker_number: 2, title: 'Locker 2' },
    { id: 'c', locker_number: 3, title: 'Locker 3' },
    { id: 'd', locker_number: 4, title: 'Locker 4' },
    { id: 'e', locker_number: 5, title: 'Locker 5' },
    { id: 'f', locker_number: 6, title: 'Locker 6' },
    { id: 'g', locker_number: 7, title: 'Locker 7' },
    { id: 'h', locker_number: 8, title: 'Locker 8' },
    { id: 'i', locker_number: 9, title: 'Locker 9' },
    { id: 'j', locker_number: 10, title: 'Locker 10' },
    { id: 'k', locker_number: 11, title: 'Locker 11' },
    { id: 'l', locker_number: 12, title: 'Locker 12' },
];

export const eventColors = [
    {
        locker_number: 1,
        backgroundColor: '#ADBC9F',
        backgroundCss: 'locker1',
    },
    {
        locker_number: 2,
        backgroundColor: '#FFBE98',
        backgroundCss: 'locker2',
    },
    {
        locker_number: 3,
        backgroundColor: '#B5C0D0',
        backgroundCss: 'locker3',
    },
    {
        locker_number: 4,
        backgroundColor: '#FDB4B4',
        backgroundCss: 'locker4',
    },
    {
        locker_number: 5,
        backgroundColor: '#B8E8FC',
        backgroundCss: 'locker5',
    },
    {
        locker_number: 6,
        backgroundColor: '#FFCF81',
        backgroundCss: 'locker6',
    },
    {
        locker_number: 7,
        backgroundColor: '#AC87C5',
        backgroundCss: 'locker7',
    },
    {
        locker_number: 8,
        backgroundColor: '#7ED7C1',
        backgroundCss: 'locker8',
    },
    {
        locker_number: 9,
        backgroundColor: '#B0A695',
        backgroundCss: 'locker9',
    },
    {
        locker_number: 10,
        backgroundColor: '#DBA39A',
        backgroundCss: 'locker10',
    },
    {
        locker_number: 11,
        backgroundColor: '#9AB4DB',
        backgroundCss: 'locker11',
    },
    {
        locker_number: 12,
        backgroundColor: '#EAE44B',
        backgroundCss: 'locker12',
    },
];

export const lockersList = [
    {
        id: 1,
        lockerName: 'Locker 01',
        value: 1,
    },
    {
        id: 2,
        lockerName: 'Locker 02',
        value: 2,
    },
    {
        id: 3,
        lockerName: 'Locker 03',
        value: 3,
    },
    {
        id: 4,
        lockerName: 'Locker 04',
        value: 4,
    },
    {
        id: 5,
        lockerName: 'Locker 05',
        value: 5,
    },
    {
        id: 6,
        lockerName: 'Locker 06',
        value: 6,
    },
    {
        id: 7,
        lockerName: 'Locker 07',
        value: 7,
    },
    {
        id: 8,
        lockerName: 'Locker 08',
        value: 8,
    },
    {
        id: 9,
        lockerName: 'Locker 09',
        value: 9,
    },
    {
        id: 10,
        lockerName: 'Locker 10',
        value: 10,
    },
];

export const selecteStates: AnyIfEmpty<object> = [
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    // { value: 'American Samoa', label: 'American Samoa' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'District Of Columbia', label: 'District Of Columbia' },
    // { value: 'Federated States Of Micronesia', label: 'Federated States Of Micronesia' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    // { value: 'Guam', label: 'Guam' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    // { value: 'Marshall Islands', label: 'Marshall Islands' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    // { value: 'Northern Mariana Islands', label: 'Northern Mariana Islands' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    // { value: 'Palau', label: 'Palau' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    // { value: 'Puerto Rico', label: 'Puerto Rico' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    // { value: 'Virgin Islands', label: 'Virgin Islands' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' },
];

export const tempTimeOptions: any = [
    { value: '00:00', label: '00:00', isBooked: false },
    { value: '01:00', label: '01:00', isBooked: false },
    { value: '02:00', label: '02:00', isBooked: false },
    { value: '03:00', label: '03:00', isBooked: false },
    { value: '04:00', label: '04:00', isBooked: false },
    { value: '05:00', label: '05:00', isBooked: false },
    { value: '06:00', label: '06:00', isBooked: false },
    { value: '07:00', label: '07:00', isBooked: false },
    { value: '08:00', label: '08:00', isBooked: false },
    { value: '09:00', label: '09:00', isBooked: false },
    { value: '10:00', label: '10:00', isBooked: false },
    { value: '11:00', label: '11:00', isBooked: false },
    { value: '12:00', label: '12:00', isBooked: false },
    { value: '13:00', label: '13:00', isBooked: false },
    { value: '14:00', label: '14:00', isBooked: false },
    { value: '15:00', label: '15:00', isBooked: false },
    { value: '16:00', label: '16:00', isBooked: false },
    { value: '17:00', label: '17:00', isBooked: false },
    { value: '18:00', label: '18:00', isBooked: false },
    { value: '19:00', label: '19:00', isBooked: false },
    { value: '20:00', label: '20:00', isBooked: false },
    { value: '21:00', label: '21:00', isBooked: false },
    { value: '22:00', label: '22:00', isBooked: false },
    { value: '23:00', label: '23:00', isBooked: false },
];

export const TourHeader = [
    { title: 'Name' },
    { title: 'Email' },
    { title: 'Contact No' },
    { title: 'Property Name' },
    { title: 'Unit Name' },
    { title: 'Locker' },
    // { title: 'Account Creation Day/Time' },
    { title: 'Appointment Day/Time' },
    { title: 'Appointment Booking Day/time' },
    { title: 'Appointment Cancellation Day/time' },
    { title: 'Appointment Rescheduled Day/time' },
    { title: 'Tour Duration' },
    { title: 'Relative Tour Start' },
    { title: 'Relative Tour End' },
    { title: "Visitor clicked\n'Apply Now'" },
];

export const visitorHeader = [
    {
        title: 'Name',
    },
    {
        title: 'Email',
    },
    {
        title: 'Contact No',
    },
    {
        title: 'Lead Property',
    },
    {
        title: 'Lead Source',
    },
    {
        title: `Desired Move\nIn Date`,
    },
    {
        title: `Desired No\nof Bedrooms`,
    },
    {
        title: `Application\nEvent Date`,
    },
    {
        title: `Lease Sign\nEvent Date`,
    },
    {
        title: 'Company/Organization',
    },
    {
        title: 'Account Created\nDate/Time',
    },
    {
        title: 'Charge',
    },
    {
        title: 'Sync',
    },
    {
        title: 'Document Verified',
    },
    {
        title: 'Card Verified',
    },
    {
        title: 'Terms & Conditions',
    },
    {
        title: 'Actions',
    },
];

export const tableHeader = [
    {
        title: 'Name',
    },
    {
        title: 'Email',
    },
    {
        title: 'Contact No',
    },
    {
        title: 'Lead Property',
    },
    {
        title: 'Desired Move In Date',
    },
    {
        title: 'Desired No of Bedrooms',
    },
    {
        title: 'Company/Organization',
    },
];

export const validateTabs: Tab[] = [
    {
        tab1: ['description', 'name', 'street1', 'streetNumber', 'state', 'city', 'zip', 'masterCode', 'appLink', 'contactLink'],
        tabIndex: 0,
    },
    { tab2: [], tabIndex: 1 },
    { tab3: [], tabIndex: 2 },
    { tab4: ['confirmText'], tabIndex: 3 },
];

export const errorsObj = {
    description: false,
    name: false,
    street1: false,
    streetNumber: false,
    state: false,
    city: false,
    zip: false,
    masterCode: false,
    appLink: false,
    contactLink: false,
    confirmText: false,
};

export const defaultOfficeHours: OfficeHoursOption[] = [
    {
        day: 'Sunday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
    {
        day: 'Monday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
    {
        day: 'Tuesday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
    {
        day: 'Wednesday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
    {
        day: 'Thursday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
    {
        day: 'Friday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
    {
        day: 'Saturday',
        openTime: '09:00',
        closeTime: '20:00',
        isOpen: true,
    },
];

export const exceptThisSymbols = ['e', 'E', '+', '-', '.'];

export const dateFormat = 'YYYY-MM-DD';

export const format12Hour = 'hh:mm A';

export const format24Hour = 'HH:mm';

export const singleDigit12HourFormat = 'h:mm A';

export const propertiesToDelete = [
    'street2',
    'yardiId',
    'yardiPassword',
    'beginningTourMessage',
    'closeTime',
    'endingTourMessage',
    'email_caption',
    'mapUrl',
    'openTime',
    'yardiServerName',
    'yardiTransactionSource',
    'yardiUrl',
    'images',
    'yardiUserName',
    'entrataPassword',
    'entrataPropertyId',
    'entrataUrl',
    'entrataUserName',
    'entrataOriginatingLeadSourceId',
    'buildingId',
    'realPagePmcID',
    'realPageSiteID',
    'realPageLicenseKey',
    'realPageUrl',
    'pineappleLeasingAgentID',
    'realPageL2LLicenseKey',
    'realPageL2LUrl',
    'realPageILMLicenseKey',
    'realPageILMUrl',
    'realPageL2LPropertyId',
    'resmanIntegrationPartnerID',
    'resmanAPIKey',
    'resmanAccountID',
    'resmanPropertyID',
    'resmanAgentID',
    'resmanTransactionSource',
];

export const colourStyles: StylesConfig<SelectProps, false, GroupBase<SelectProps>> = {
    control: (base: CSSObjectWithLabel) => ({
        ...base,
        height: 48,
        minHeight: 48,
    }),

    option: (styles: CSSObjectWithLabel, { isDisabled, isFocused, isSelected }: OptionProps<SelectProps, false, GroupBase<SelectProps>>) =>
        ({
            ...styles,
            backgroundColor: isFocused ? '#E59236' : isSelected ? '#E59236' : null,
            color: isFocused ? '#fff' : isSelected ? '#fff !important' : null,
            cursor: isDisabled ? 'not-allowed' : 'default',
        }) as CSSObjectWithLabel,
};

export const getColourStyles = (isError?: boolean): StylesConfig<SelectProps, false, GroupBase<SelectProps>> => ({
    control: (base: CSSObjectWithLabel) => ({
        ...base,
        height: 48,
        minHeight: 48,
        // borderColor: isError ? 'red' : base.borderColor,
    }),

    option: (styles: CSSObjectWithLabel, { isDisabled, isFocused, isSelected }: OptionProps<SelectProps, false, GroupBase<SelectProps>>) =>
        ({
            ...styles,
            backgroundColor: isFocused ? '#E59236' : isSelected ? '#E59236' : null,
            color: isFocused ? '#fff' : isSelected ? '#fff !important' : null,
            cursor: isDisabled ? 'not-allowed' : 'default',
        }) as CSSObjectWithLabel,
});

export const DEBOUNCE_DELAY = 1000;

export const weekdaysOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const REGEX = {
    EMAIL: /^[A-Za-z0-9](?:[A-Za-z0-9._+-]*[A-Za-z0-9])?@(?:[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,6}$/,
    PASSWORD: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,12}$/,
    ALPHA_NUMERIC_WITH_SPACE: /^(?![ ])[a-zA-Z0-9 ]*$/,
    URL: /^https:\/\/www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/,
};

export const LockersOption: LockerOption[] = [
    // { value: 0, label: 'Variable (Luxer)' },
    { value: 4, label: 4 },
    { value: 10, label: 10 },
    { value: 12, label: 12 },
];

export const LockersVersion: LockerVersion[] = [
    { value: 'V2', label: 'V2' },
    { value: 'V3', label: 'V3' },
];

export const allUsTerritories = [
    'American Samoa',
    'Guam',
    'Northern Mariana Islands',
    'Puerto Rico',
    'U.S. Virgin Islands',
    'Baker Island',
    'Howland Island',
    'Jarvis Island',
    'Johnston Atoll',
    'Kingman Reef',
    'Midway Atoll',
    'Navassa Island',
    'Palmyra Atoll',
    'Wake Island',
];

export const supportTicketHeader = [
    {
        title: 'Ticket ID',
    },
    {
        title: 'Subject',
    },
    {
        title: 'Location',
    },
    {
        title: 'Name',
    },
    {
        title: 'Email',
    },
    {
        title: 'Status',
    },
    {
        title: 'Created',
    },
    {
        title: 'Last Updated',
    },
    {
        title: 'Actions',
    },
];

export const supportTicketData = [
    {
        id: 'TKT-5846212',
        subject: 'ResMan PMS sync failure - Room rates not updating',
        status: 'Open',
        createdAt: '02-04-2026, 2:00 PM',
        updatedAt: null,
    },
    {
        id: 'TKT-5845421',
        subject: 'Unable to sync property units from Mews',
        status: 'In Progress',
        createdAt: '02-01-2026, 5:00 PM',
        updatedAt: '02-01-2026, 8:00 PM',
    },
    {
        id: 'TKT-5845124',
        subject: 'Billing inquiry - Incorrect charge on invoice',
        status: 'In Progress',
        createdAt: '02-01-2026, 11:00 AM',
        updatedAt: '02-01-2026, 6:00 PM',
    },
    {
        id: 'TKT-5844921',
        subject: 'Feature request: Bulk property import',
        status: 'Resolved',
        createdAt: '01-15-2026, 7:00 AM',
        updatedAt: '01-15-2026, 7:00 AM',
    },
    {
        id: 'TKT-5844511',
        subject: 'Cloudbeds integration showing incorrect availability',
        status: 'Resolved',
        createdAt: '01-12-2026, 7:00 AM',
        updatedAt: '01-12-2026, 7:00 AM',
    },
];

export const supportTicketDetails: { [key: string]: any } = {
    'TKT-5844511': {
        id: 'TKT-5844511',
        subject: 'Cloudbeds Integration Showing Incorrect Availability',
        description:
            'The availability data synced from Cloudbeds is showing incorrect results on our platform. Some units appear available when they are already booked, and others are marked unavailable despite being open in Cloudbeds. This mismatch is affecting inventory accuracy and booking reliability. Please investigate and advise on a resolution.',
        status: 'Resolved',
        createdAt: '01-12-2026, 7:00 AM',
        updatedAt: '01-12-2026, 7:00 AM',
        messages: [
            {
                id: 1,
                author: 'Esther Howard',
                date: '01-12-2026, 10:15 AM',
                content:
                    "Thank you for bringing this to our attention. We've received your request regarding the Cloudbeds availability sync issue, and our support team has begun reviewing the details. We understand how important accurate availability is for your bookings, and we'll keep you informed as we investigate this further.",
                avatar: '',
            },
            {
                id: 2,
                author: 'Esther Howard',
                date: '01-14-2026, 3:30 PM',
                content:
                    "Our team is actively investigating the availability discrepancies between Cloudbeds and our platform. We're analyzing the sync logs and validating data updates to ensure the correct availability is reflected. We appreciate your patience and will share another update as soon as we make progress or need additional information.",
                avatar: '',
            },
            {
                id: 3,
                author: 'Esther Howard',
                date: '01-15-2026, 9:00 AM',
                content:
                    "The issue with Cloudbeds availability syncing has now been resolved. Availability data is now correctly synced and updated on the platform. We've conducted additional checks to ensure ongoing accuracy. Please review the availability on your end and let us know if you experience any further issues—we're happy to assist.",
                avatar: '',
            },
        ],
    },
    'TKT-5846212': {
        id: 'TKT-5846212',
        subject: 'Subject: ResMan PMS Sync Failure - Room Rates Not Updating',
        description:
            'Our front desk are not syncing correctly from the backup units. The rates displayed on our platform appear to be outdated by approximately three days, which is causing discrepancies in pricing and impacting our booking process. We request your assistance in identifying and resolving this sync issue at the earliest.',
        status: 'In Progress',
        createdAt: '02-01-2026, 2:00 PM',
        updatedAt: '02-03-2026, 4:30 PM',
        messages: [
            {
                id: 1,
                author: 'Esther Howard',
                date: '02-01-2026, 4:15 PM',
                content:
                    "We've identified the cause of the delay in rate synchronization from your PMS. It seems that the API hook is actively investigating this and we'll have a fix in update over the next a few hours. Thank you for your patience.",
                avatar: '',
            },
            {
                id: 2,
                author: 'Esther Howard',
                date: '02-02-2026, 11:30 AM',
                content:
                    "Thank you for bringing this to our attention. We're currently reviewing the issue with the ResMan PMS rate sync and will get back to you with an update as soon as possible.",
                avatar: '',
            },
        ],
    },
};

export const getLockerColor = (lockerNumber: number) => {
    const colors: Record<number, string> = {
        1: '#adbc9f',
        2: '#ffbe98',
        3: '#b5c0d0',
        4: '#fdb4b4',
        5: '#b8e8fc',
        6: '#ffcf81',
        7: '#ac87c5',
        8: '#7ed7c1',
        9: '#b0a695',
        10: '#dba39a',
        11: '#9ab4db',
        12: '#eae44b',
    };

    return colors[lockerNumber] || '#ccc';
};

export const datePresetOptions = [
    { value: 'This week', label: 'This week' },
    { value: 'Last week', label: 'Last week' },
    { value: 'This month', label: 'This month' },
    { value: 'Last month', label: 'Last month' },
    { value: 'Custom', label: 'Custom' },
];